// Helpers wrapping window.fbq safely (no crash if pixel script blocked by ad-blocker).
export function trackEvent(eventName, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", eventName, params);
    }
  } catch {
    /* noop */
  }
}

export const fbq = {
  lead: (params = {}) => trackEvent("Lead", params),
  contact: (params = {}) => trackEvent("Contact", params),
  initiateCheckout: (params = {}) => trackEvent("InitiateCheckout", params),
  viewContent: (params = {}) => trackEvent("ViewContent", params),
  schedule: (params = {}) => trackEvent("Schedule", params),
};
